'use es6';

import Actions from 'AdsUI/lib/Actions';
import { Map as ImmutableMap } from 'immutable';
import DraftRecord from 'AdsUI/records/ad-management/DraftRecord';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.DRAFTS_FETCH_SUCCEEDED:
      {
        if (!payload || !payload.drafts) {
          return state;
        }

        const {
          drafts
        } = payload;
        return state.withMutations(mutableState => drafts.forEach(draft => {
          mutableState.set(draft.id, new DraftRecord(draft));
        }));
      }

    case Actions.DRAFT_DELETE_START:
      {
        const {
          draft
        } = payload;
        return state.delete(draft.id);
      }

    case Actions.LEAD_AD_DRAFT_CREATE_SUCCEEDED:
    case Actions.LEAD_AD_DRAFT_UPDATE_SUCCEEDED:
    case Actions.SEQUENCE_DRAFT_CREATE_SUCCEEDED:
    case Actions.SEQUENCE_DRAFT_UPDATE_SUCCEEDED:
      {
        if (!payload) {
          return state;
        }

        return state.set(payload.id, new DraftRecord(payload));
      }

    default:
      {
        return state;
      }
  }
});